import React from 'react';
import { Alert } from 'react-bootstrap';

const AlertMessage = ({ variant, message }) => {
  return (
    <Alert variant={variant || 'info'} className="mb-4">
      {message}
    </Alert>
  );
};

export default AlertMessage;
